import { bl_aat_engagement_company_to_company_access_link_RowClass } from '../../../dbschema/bl_aat_engagement_company_to_company_access_link.model';
import { BaseContainerModel } from '../../base-container.model';

export class EngagementCompanyToCompanyAccessLinkContainerModel extends BaseContainerModel {
    bl_aat_engagement_company_to_company_access_link: bl_aat_engagement_company_to_company_access_link_RowClass = new bl_aat_engagement_company_to_company_access_link_RowClass();
}